module.exports = __webpack_public_path__ + "static/img/102422.a1926dae.png";